/**
 * CardSequence — renders a sequence of playing cards.
 *
 * data: { cards: ["3♥", "5♦", "7♣", "?"] }
 *
 * Each card string: number/face + suit symbol (♥♦♣♠)
 * "?" renders as a mystery card.
 */

const SUIT_COLORS = {
    '♥': '#dc2626',
    '♦': '#dc2626',
    '♣': '#1e293b',
    '♠': '#1e293b',
};

function parseCard(card) {
    if (!card || card === '?') return { value: '?', suit: '', color: '#6366f1', isMystery: true };
    const suit = card.slice(-1);
    const value = card.slice(0, -1);
    return { value, suit, color: SUIT_COLORS[suit] || '#1e293b', isMystery: false };
}

export default function CardSequence({ data }) {
    // Accept both { cards: ["3♥","5♦"] } and { card: "3♥" } for single card
    const cards = data?.cards || (data?.card ? [data.card] : null);
    if (!Array.isArray(cards) || cards.length === 0) return null;

    return (
        <div className="qv-cards">
            {cards.map((c, i) => {
                const { value, suit, color, isMystery } = parseCard(c);
                return (
                    <div key={i} className={`qv-card ${isMystery ? 'qv-card--mystery' : ''}`}>
                        {isMystery ? (
                            <span className="qv-card__mystery">?</span>
                        ) : (
                            <>
                                <span className="qv-card__corner qv-card__corner--top" style={{ color }}>
                                    <span className="qv-card__value">{value}</span>
                                    <span className="qv-card__suit">{suit}</span>
                                </span>
                                <span className="qv-card__center" style={{ color }}>{suit}</span>
                                <span className="qv-card__corner qv-card__corner--bottom" style={{ color }}>
                                    <span className="qv-card__value">{value}</span>
                                    <span className="qv-card__suit">{suit}</span>
                                </span>
                            </>
                        )}
                    </div>
                );
            })}
        </div>
    );
}
